<div class="factory-container">
  <div class="mb-24 d-flex img-container">
    @if (!productData?.isAddedByManufacturer && user.type !== utils.userTypes.Admin) {
      <div>
        <div (click)="addProductImage()" class="add-rectangle cursor d-inline-flex justify-content-center align-items-center">
          <mat-icon class="add-icon" i18n-label="@@addProductIcon" aria-label="Add product image">add</mat-icon>
        </div>
      </div>
    }
    @for (img of imagesList; track img; let i = $index) {
      <div class="d-inline-flex flex-column align-items-center ml-8">
        <img [src]="img" class="image" i18n-alt="@@productImageAlt" alt="Product image"/>
        <mat-icon (click)="spliceProductImage(i)" color="warn" class="delete-icon cursor" i18n-label="@@deleteProductImageIcon" aria-label="Delete product image">cancel</mat-icon>
      </div>
    }
    @for (img of productData?.pictures; track img; let i = $index) {
      <div class="d-inline-flex flex-column align-items-center ml-8">
        <img [src]="img.picturePath" class="image" i18n-alt="@@productImageAlt" alt="Product image"/>
        @if (ownInfoChecked && !productData?.isAddedByManufacturer && user.type !== utils.userTypes.Admin) {
          <mat-icon (click)="deleteProductImage(i, img.id)" color="warn" class="delete-icon cursor" i18n-label="@@deleteProductImageIcon" aria-label="Delete product image">cancel</mat-icon>
        }
      </div>
    }
  </div>

  <form [formGroup]="productGeneralForm">
    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@productNameLabel">Product name</mat-label>
        <input data-testid="product_name" matInput id="name" placeholder="Product name" i18n-placeholder="@@productNamePlaceholder" name="name" formControlName="name" required/>
        <mat-error>
          @if (!productGeneralForm.get('name').valid && productGeneralForm.get('name').touched) {
            @if (productGeneralForm.get('name').errors && productGeneralForm.get('name').errors['required'] || productGeneralForm.get('name').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@createdOnLabel">Created on</mat-label>
        <input disabled data-testid="createdDate" matInput id="createdDate" placeholder="Created on" i18n-placeholder="@@createdOnPlaceholder" name="createdDate" formControlName="createdDate" required/>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@descriptionLabel">Description</mat-label>
        <input data-testid="description" matInput id="description" placeholder="Description" i18n-placeholder="@@descriptionPlaceholder" name="description" formControlName="description" required/>
        <mat-error>  
          @if (!productGeneralForm.get('description').valid && productGeneralForm.get('description').touched) {
            @if (productGeneralForm.get('description').errors && productGeneralForm.get('description').errors['required'] || productGeneralForm.get('description').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <div class="form-group">
      <mat-form-field class="w-100" appearance="outline">
        <mat-label i18n="@@purposeLabel">Purpose</mat-label>
        <input data-testid="purpose" matInput id="purpose" placeholder="Purpose" i18n-placeholder="@@purposePlaceholder" name="purpose" formControlName="purpose" required/>
        <mat-error>
          @if (!productGeneralForm.get('purpose').valid && productGeneralForm.get('purpose').touched) {
            @if (productGeneralForm.get('purpose').errors && productGeneralForm.get('purpose').errors['required'] || productGeneralForm.get('purpose').hasError('whitespace')) {
              <span i18n="@@inValidRequiredField">This field is required</span>
            }
          }
        </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field class="w-100" appearance="outline">
      <mat-chip-grid #chipList [disabled]="departmentCtrl.disabled">
        @for (department of departments; track department; let index = $index) {
          <mat-chip-row
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(department, index)">
            {{department.name}}
            @if (removable) {
              <mat-icon matChipRemove i18n-label="@@removeDepartmentIcon" aria-label="Remove department">cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          data-testid="edit_product_department_input"
          (keyup)="searchDepartment($event)"
          placeholder="Departments *"
          #departmentInput
          [formControl]="departmentCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
           i18n-placeholder="@@departmentsPlaceholder">
      </mat-chip-grid>
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
        @for (department of filteredDepartments | async; track department) {
          <mat-option [value]="department">
            {{department.name}}
          </mat-option>
        }
      </mat-autocomplete>
      @if (isLoading) {
        <mat-icon class="cursor" matSuffix i18n-label="@@loadingSpinnerIcon" aria-label="Loading">
          <mat-spinner class="spinner" diameter="20"></mat-spinner>
        </mat-icon>
      }
    </mat-form-field>

    @if (departments.length === 0) {
      <div i18n="@@invalidDepartmentsMessage" class="error">Please enter departments to proceed</div>
    }

    @if (userType !== 2 && userType !== 3 && productData?.isAddedByManufacturer) {
      <mat-card class="mb-12">
        <mat-card-content class="d-flex justify-content-between align-items-center">
          <div i18n="@@provieOwnInfo" class="mat-subtitle-1" matTooltip ellipsisTooltip>Provide Own General Information</div>
          <mat-slide-toggle #toggleElement [checked]="ownInfoChecked" (change)="toggle($event)" i18n-label="@@toggleOwnInfo" aria-label="Toggle own information"></mat-slide-toggle>
        </mat-card-content>
      </mat-card>
    }

    @if (userType !== 2 && userType !== 3 && productData?.isAddedByManufacturer) {
      <div i18n="@@provieOwnInfoDescription" class="mat-caption mb-12" matTooltip ellipsisTooltip>You can only provide own information for description, purpose, and prospects departments.</div>
    }

    @if (user.type !== utils.userTypes.Admin) {
      <div class="factory-button mb-12">
        <button i18n="@@deleteProduct" class="mr-6" data-testid="product_delete_button" mat-raised-button color="warn" (click)="deleteProduct()">Delete Product</button>
        <button i18n="@@saveChanges" data-testid="product_save_button" mat-raised-button color="primary" (click)="onSubmit()">Save Changes</button>
      </div>
    }
  </form>
</div>
